import clsx from 'clsx';
import { Content } from 'src/contexts/ContentContext';
import { SimpleTable, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as tableStyles from '../../../SaleDetailsTable.css';
import * as styles from './PaymentSectionTable.css';

export const SaleCostRow = ({
  titleContentId,
  subtitleContentId,
  displayValue,
  originalDisplayValue,
  rowStyle = styles.costCell,
}: {
  titleContentId: ContentId;
  subtitleContentId?: ContentId;
  displayValue?: string | null;
  originalDisplayValue?: string | null;
  rowStyle?: string;
}) => {
  return (
    <SimpleTable.Tr className={clsx(rowStyle, tableStyles.tableRow)}>
      <SimpleTable.Td className={tableStyles.tableCell}>
        <Stack alignItems="center" gap="s">
          <Content id={titleContentId} />
          {subtitleContentId && (
            <span className={styles.cellExplanation}>
              <Content id={subtitleContentId} />
            </span>
          )}
        </Stack>
      </SimpleTable.Td>
      <SimpleTable.Td
        className={clsx(tableStyles.alignRight, tableStyles.tableCell)}
      >
        {originalDisplayValue && (
          <span className={styles.originalProceeds}>
            {originalDisplayValue}{' '}
          </span>
        )}
        {displayValue ?? <Content id={ContentId.NA} />}
      </SimpleTable.Td>
      <SimpleTable.Td className={tableStyles.tableCell} />
      <SimpleTable.Td className={tableStyles.tableCell} />
      <SimpleTable.Td className={tableStyles.tableCell} />
      <SimpleTable.Td className={tableStyles.tableCell} />
    </SimpleTable.Tr>
  );
};
